import { useSearchParams } from 'react-router-dom';
import Header from "../../components/header";
import { Footer } from "../../components/Footer";
import { ReactComponent as HSBC } from '../../icons/HSBC.svg';
import { ReactComponent as OXXO } from '../../icons/Oxxo.svg';
import { ReactComponent as PhoneIcon } from '../../icons/telephone.svg';
import { ReactComponent as MessageIcon } from '../../icons/message.svg';
import plans from '../../lib/plans';

import '../../scss/payment.scss';

export default function Payment() {
  const [searchParams] = useSearchParams();
  const planId = searchParams.get('plan');
  const selectedPlan = plans.find(plan => plan.id === planId) || plans[0];

  return(
    <div className="payment-page">
      <Header />
      <main className="payment-content">
        <div className="container">
          <div className="payment-methods">
            
            <div className="payment-method hsbc-method">
              <div className="method-header">
                <HSBC className="method-icon"/>
                <h3>Transferencia Bancaria HSBC</h3>
              </div>
              <div className="method-content">
                <div className="bank-details">
                  <div className="detail-item">
                    <span className="detail-label">Número de tarjeta:</span>
                    <span className="detail-value">4213 1661 4154 4928</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">No. de cuenta:</span>
                    <span className="detail-value">6529038213</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">CLABE:</span>
                    <span className="detail-value">021580065290382137</span>
                  </div>
                </div>
                <div className="method-note">
                  <p>Realiza tu transferencia y envíanos el comprobante por WhatsApp</p>
                </div>
              </div>
            </div>

            <div className="payment-method oxxo-method">
              <div className="method-header">
                <OXXO className="method-icon" />
                <h3>Pago en OXXO</h3>
              </div>
              <div className="method-content">
                <div className="oxxo-instructions">
                  <div className="instruction-step">
                    <span className="step-number">1</span>
                    <p>Deposita el monto de <a href='/#planes'><strong>Tu Plan</strong></a> en cualquier OXXO</p>
                  </div>
                  <div className="instruction-step">
                    <span className="step-number">2</span>
                    <p>Toma <strong>Foto 📸</strong> de tu ticket de depósito</p>
                  </div>
                  <div className="instruction-step">
                    <span className="step-number">3</span>
                    <p>Envía la foto por <strong>WhatsApp 💬</strong> al número:</p>
                  </div>
                </div>
                <div className="contact-info">
                  <a href="tel:8180178779" className="contact-button">
                    <PhoneIcon className="contact-icon" />
                    <span>81 80 17 87 79</span>
                  </a>
                </div>
              </div>
            </div>

          </div>

          <div className="payment-support">
            <div className="support-content">
              <h3>¿Necesitas ayuda con tu pago?</h3>
              <p>Nuestro equipo está listo para ayudarte con cualquier duda sobre el proceso de pago.</p>
              <div className="support-contacts">
                <a href="tel:8180178779" className="support-contact">
                  <PhoneIcon className="support-icon" />
                  <div>
                    <span className="contact-label">Teléfono</span>
                    <span className="contact-value">81 80 17 87 79</span>
                  </div>
                </a>
                <a href="mailto:Interhomecontacto@gmail.com" className="support-contact">
                  <MessageIcon className="support-icon" />
                  <div>
                    <span className="contact-label">Email</span>
                    <span className="contact-value">Interhomecontacto@gmail.com</span>
                  </div>
                </a>
              </div>
            </div>
          </div>

        </div>
      </main>
      <Footer />
    </div>
  )
}
